/**
 * Central SEO config: category landing pages, verticals, and sitemap helpers.
 */
import categoryMeta from './seo-categories.json';
import { SEO_LANDING_PATHS } from './seoLandingPages';

export const SITE_URL = 'https://flea-marketplace.com';
export const SITE_NAME = 'Flea Marketplace';

const slugify = (value = '') =>
  String(value)
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '') || 'items';

export const SEO_CATEGORY_PAGES = categoryMeta.map((c) => {
  const slug = slugify(c.categoryValue);
  return {
    ...c,
    slug,
    path: `/buy/${slug}`,
    title: `Buy & Sell Used ${c.name} in Egypt | Flea Marketplace`,
    h1: `Used ${c.name} Marketplace in Egypt`,
    description: `Browse and list used ${c.name.toLowerCase()} in Egypt on Flea Marketplace. Buy from trusted sellers in Cairo and across Egypt, or sell your pre-owned ${c.name.toLowerCase()} with fair prices, delivery options, and Aura reputation scores.`,
  };
});

export const SEO_VERTICAL_PAGES = [
  {
    path: '/wedding-essentials',
    title: 'Pre-owned Wedding & Occasion Wear Marketplace in Egypt',
    h1: 'Pre-owned Wedding & Occasion Wear Marketplace in Egypt',
    description:
      'Shop and sell wedding dresses, bridal accessories, grooms wear, and pre-loved wedding items in Egypt. Bridal gowns, veils, shoes, and event essentials in Cairo and nationwide.',
    keywords:
      'bridal dresses Cairo, wedding gowns Egypt, second hand wedding dress, sell used wedding dress Egypt, preloved bridal Egypt',
  },
  {
    path: '/designers',
    title: 'Designers & Pre-Owned Fashion in Egypt | Flea Marketplace',
    h1: 'This page is for brand-new items from exclusive Egyptian designers.',
    description: '',
    keywords: 'designer fashion Egypt, pre-owned designer clothes Cairo, luxury resale Egypt',
  },
  {
    path: '/luxury',
    title: 'Pre-Owned Luxury Pieces in Egypt | Flea Marketplace',
    h1: '',
    description: '',
    keywords: 'pre-owned luxury Egypt, secondhand luxury bags Cairo, luxury resale marketplace',
  },
  {
    path: '/boutiques',
    title: 'Boutiques & Curated Fashion in Egypt | Flea Marketplace',
    h1: '',
    description: '',
    keywords: 'boutique fashion Egypt, curated preloved Cairo',
  },
  {
    path: '/artists',
    title: 'Artists & Creative Works in Egypt | Flea Marketplace',
    h1: 'Discover Unique Artwork from Talented Artists in Egypt',
    description:
      'Browse and buy unique artwork, handcrafted items, and creative pieces from talented artists across Egypt on Flea Marketplace.',
    introDescription: '',
    keywords: 'artists Egypt, artwork Cairo, handmade crafts Egypt, creative marketplace',
  },
];

export const SEO_STATIC_PAGES = [
  { path: '/', priority: '1.0', changefreq: 'daily' },
  { path: '/pre-owned-items', priority: '0.9', changefreq: 'daily' },
  { path: '/faq', priority: '0.8', changefreq: 'monthly' },
  { path: '/support', priority: '0.8', changefreq: 'monthly' },
  { path: '/terms', priority: '0.5', changefreq: 'monthly' },
  { path: '/privacy', priority: '0.5', changefreq: 'monthly' },
  { path: '/data-deletion', priority: '0.4', changefreq: 'monthly' },
  { path: '/login', priority: '0.6', changefreq: 'monthly' },
  { path: '/register', priority: '0.7', changefreq: 'monthly' },
  { path: '/what-to-offer', priority: '0.7', changefreq: 'weekly' },
  ...SEO_LANDING_PATHS.map((path) => ({ path, priority: '0.8', changefreq: 'weekly' })),
];

export function getCategorySeoBySlug(slug) {
  if (!slug) return null;
  const normalized = slugify(slug);
  return SEO_CATEGORY_PAGES.find((p) => p.slug === normalized) || null;
}

export function getCategorySeoByValue(categoryValue) {
  if (!categoryValue) return null;
  return SEO_CATEGORY_PAGES.find((p) => p.categoryValue === categoryValue) || null;
}

export function getAllSitemapPaths() {
  const today = new Date().toISOString().slice(0, 10);
  const entries = [];
  const add = (path, priority = '0.7', changefreq = 'weekly') => {
    entries.push({ path, priority, changefreq, lastmod: today });
  };
  SEO_STATIC_PAGES.forEach((p) => add(p.path, p.priority, p.changefreq));
  SEO_VERTICAL_PAGES.forEach((p) => add(p.path, '0.85', 'weekly'));
  SEO_CATEGORY_PAGES.forEach((p) => add(p.path, '0.8', 'daily'));
  return entries;
}
